export default [
  {
    path: '/games',
    name: 'games',
    component: () => import('@/views/game/GamesList.vue'),
  },
  {
    path: '/games/edit/:id',
    name: 'game-edit',
    component: () => import('@/views/game/GameEdit.vue'),
    meta: {
      navActiveLink: 'games',
    },
  },
  {
    path: '/games/new',
    name: 'random-game-create',
    component: () => import('@/views/game/RandomGameCreate.vue'),
  },
  {
    path: '/games/schedule-import',
    name: 'schedule-import',
    component: () => import('@/views/game/ScheduleImport.vue'),
  },
]
